import Service from './Service'

export default class OriginService extends Service {
  getStats (query) {
    return this.axios.get('stats/origin', {params: query})
  }
}



// WEBPACK FOOTER //
// ./src/services/api/OriginService.js